module.exports = "/**\n * Function to create an optimized svg url\n */\n/**\n * Replace `$search` with `$replace` in `$string`\n * @author Hugo Giraudel\n * @param {String} $string - Initial string\n * @param {String} $search - Substring to replace\n * @param {String} $replace ('') - New value\n * @return {String} - Updated string\n */\n/deep/ signature-pad {\n  cursor: crosshair; }\n\n/deep/ canvas, img {\n  display: block; }\n\n.signature-container {\n  border: 2px solid rgba(0, 0, 0, 0.4); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forms/controls/signature/signature-modal.component.scss
// module id = 1414
// module chunks = 0